export class ApplicationStatusParent {
  constructor() {
    this.list = []
  }

  addApplicationStatus(item) {
    this.list.push(ApplicationStatus.buildFromAPI(item))
  }

  updateApplicationStatus(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    this.list.splice(index, 1, ApplicationStatus.buildFromAPI(item))
  }

  removeApplicationStatus(id) {
    const index = this.list.findIndex(el => el.id === id)
    this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  buildFromAPI(obj) {
    if (obj) {
      this.list = obj.map(el => ApplicationStatus.buildFromAPI(el))
    }
    return this
  }
}

export class ApplicationStatus {
  constructor() {
        this.id = null
        this.name = null
      }

  getForAPI() {
    return {
            id: this.id,
            name: this.name,
          }
  }

  static buildFromAPI(obj) {
    const _this = new ApplicationStatus()
    if (obj) {
            _this.id = obj.id
            _this.name = obj.name
          }
    return _this
  }
}